<template>
  <!-- :bodyStyle="{paddingTop:'0px'}" :headStyle="{borderBottom:'0px'}" -->
  <a-card :bordered="false" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="2">
        <search-list>
          <a-form-item label="广告场景" v-bind="searchItemLayout">
            <a-select style="width: 100%" v-model="queryParams.adScene" placeholder="请选择" allowClear>
              <a-select-option :value="1">弹窗广告</a-select-option>
              <!-- <a-select-option :value="2">动态信息</a-select-option>
              <a-select-option :value="3">横幅</a-select-option>
              <a-select-option :value="4">详情</a-select-option> -->
              <a-select-option :value="5">首页搜索广告</a-select-option>
              <a-select-option :value="6">搜索发现广告</a-select-option>
              <a-select-option :value="7">开屏广告</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="投放时间" v-bind="searchItemLayout">
            <a-range-picker @change="onOrderDateChange" :value="selectedOrderDate" style="width: 100%"/>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="广告名称" v-bind="searchItemLayout">
            <a-input v-model="queryParams.adName" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item style="margin-left:10%;">
            <a-button type="primary" @click="searchBtn">查询</a-button>
            <a-button icon="plus" @click="createEvent(0,0)">新建</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      rowKey="id"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <template slot="contentSlots" slot-scope="data">
        <a-tooltip placement="topLeft">
          <template slot="title">{{ data.record.content }}</template>
          <div class="pro_content">{{ data.record.content }}</div>
        </a-tooltip>
      </template>
      <template slot="timeSlots" slot-scope="data">
        <span>{{ data.record.validStartTimeStr }}至{{ data.record.validEndTimeStr }}</span>
      </template>
      <div slot="action" slot-scope="data">
        <span v-if="data.record.status==0">
          <a @click="createEvent(data.record.id,data.record.status)">修改</a>
          <a-divider type="vertical"/>
          <a @click="handleUpdata(data.record.id,1)">上线</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="是否要删除该条数据?" @confirm="deleteData(data.record.id)">
            <a>删除</a>
          </a-popconfirm>
        </span>
        <span v-if="data.record.status==1">
          <a @click="createEvent(data.record.id,data.record.status)">查看</a>
          <a-divider type="vertical"/>
          <a @click="handleUpdata(data.record.id,2)">下线</a>
          <a-divider type="vertical"/>
          <a @click="goStatistics(data.record.id)">数据统计</a>
        </span>
        <span v-if="data.record.status==2">
          <a @click="createEvent(data.record.id,data.record.status)">查看</a>
          <a-divider type="vertical"/>
          <a-popconfirm title="是否要删除该条数据?" @confirm="deleteData(data.record.id)">
            <a>删除</a>
          </a-popconfirm>
          <a-divider type="vertical"/>
          <a @click="goStatistics(data.record.id)">数据统计</a>
        </span>
      </div>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchForm from '@/utils/mixins/searchFormMixins'

export default {
  name: 'AdvertisingList',
  mixins: [searchForm],
  data() {
    return {
      selectedOrderDate: undefined,
      paymentList: [],
      merchantId: this.$store.getters.userInfo.merchantId,
      queryParams: {},
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: 'ID',
          dataIndex: 'id'
        },
        {
          title: '广告场景',
          dataIndex: 'adSceneStr'
        },
        {
          title: '广告位置',
          dataIndex: 'adPositionText'
        },
        {
          title: '内容类型',
          dataIndex: 'typeText'
        },
        {
          title: '关联商品/广告链接',
          dataIndex: 'content',
          width: '170px',
          scopedSlots: { customRender: 'contentSlots' }
        },
        {
          title: '广告名称',
          dataIndex: 'adName'
        },
        {
          title: '投放时间',
          dataIndex: 'validEndTimeStr',
          scopedSlots: { customRender: 'timeSlots' }
        },
        {
          title: '状态',
          dataIndex: 'statusStr',
          width: '75px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '180px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'AdvertisingList', title: '广告列表' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getOrderListPromise==', params)
      return this.getHttpServices().getUserService().post('api/v2/ad/list', params)
    },
    //日期变更
    onOrderDateChange(dates, dateStrArr) {
      this.selectedOrderDate = dates
      this.queryParams.validStartTime = dateStrArr[0]//下单开始时间
      this.queryParams.validEndTime = dateStrArr[1]//下单结束时间
    },
    searchBtn() {
      this.$refs.table.refresh(true)
    },
    createEvent(adId, status) {
      this.getLogUtils().logWithTag('record==', adId)
      this.$router.push({
        name: 'NewAdvertisiing',
        query: {
          adId: adId,
          status: status,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    goStatistics(adId) {
      this.$router.push({
        name: 'DataStatsList',
        query: {
          adId: adId,
          serverUniqueId: this.$route.query.serverUniqueId
        }
      })
    },
    //删除数据
    deleteData(adId) {
      this.getHttpServices().getUserService().post('api/v2/ad/delete', {
        adId: adId
      }).then(res => {
        this.$message.success('删除成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    // 上下架
    handleUpdata(adId, status) {
      let text = status == 1 ? '上线' : '下线'
      this.getHttpServices().getUserService().post('api/v2/ad/operate', {
        adId: adId,
        status: status
      }).then(res => {
        this.getLogUtils().logWithTag('handleUpdata', res)
        this.$message.success(text + '成功')
        this.$refs.table.refresh(true)
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    }
  }

}
</script>
<style scoped>
.ant-btn + .ant-btn {
  margin-left: 10px;
}

.price-class {
  color: #fea834;
}

.pro_content {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>